import View from './View';
import logo from 'url:../../../src/img/logo.png';

class LoginView extends View {
  _parentElement = document.querySelector('.popup__container');
  _errorMessage = 'Signup Error Message';
  _message = 'Signup Success Message';

  addHandlerLogin(handler) {
    const loginForm = document.querySelector('.user-cred__form');

    if (!loginForm) return;
    const loginBtn = document.querySelector('.btn--login');
    loginForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      loginBtn.disabled = true;
      loginBtn.textContent = 'Loging in...'; // Update text for feedback

      const dataArr = [...new FormData(this)];
      const data = Object.fromEntries(dataArr);
      handler(data);
    });
  }

  _generateMarkup() {
    const markup = `
      <div class="user-cred">
        <div class="user-cred__head">          
          <h1 class="user-cred__heading">Login to Account</h1>           
        </div>
        <div class="user-cred__container">
          <div class="user-cred__logo">
            <div class="user-cred__logo--img">
              <img src="${logo}" alt="Pragya Enterprises Logo" />
            </div>
            <h3 class="user-cred__title"></h3>
            <p class="paragraph user-cred__description">
              For every student, every classroom.<br />
              Real uniforms.
            </p>
          </div>
          <div class="user-cred__form--container">
            <form
              action="#"
              class="user-cred__form"
              name="userCredForm"
              autocomplete="off"
            >
              <!-- EMAIL -->
              <div class="user-cred__email label-input">
                <label for="email">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="hello@pragya.enterprises"
                  name="email"
                  autofocus
                  required
                  value=""
                />
              </div>

              <!-- PASSWORD -->
              <div class="user-cred__email label-input">
                <label for="password">Password</label>
                <input
                  type="password"
                  placeholder="enter new password"
                  name="password"
                  id="password"
                  required
                />
              </div>
              <div class="user-cred__btn--container">
                <button type="submit" class="btn btn--login">Login</button>                
              </div>
            </form>
          </div>
        </div>
        
      </div>
    `;

    return this._addToPopup(markup);
  }
}

export default new LoginView();
